module.exports = __webpack_public_path__ + "img/0Q3A0072_L_Black_MockedUp.3bc15d15.jpg";